import { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import RMultilingual from '../Multilingual';
import toast from '~~elements/Toast';
import { SeasonRegistryResource } from '~~apis/resource';
import { RegistrySectionDiv } from '../../styled';
import { useRegistryState } from '../useRegistry';
import ReviewTeamList from './ReviewTeamList';

export const statusList = ['SIGNED_UP', 'REVIEW_REQUESTED', 'REVIEW_COMPLETED', 'PAYMENT_CHECK_REQUESTED', 'COMPLETED'];

const StatusTitleDiv = styled.div`
  width: 100%;
  text-align: start;
  margin: 0.25rem;
  padding: 0.25rem 0 0.25rem 0.5rem;
  border-bottom: 1px solid gray;
  ${(props) => (props.selected ? '' : 'box-shadow: 1px 1px 2px 0px black;')}
  border-radius: 0 0 5px 0;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  .title {
    color: ${(props) => (props.disabled ? 'gray' : 'black')};
    font-size: 1.2rem;
    font-weight: normal;
    margin: 0.2rem 0;
  }
  .subtitle {
    color: gray;
    font-size: 1rem;
    margin: 0.1rem 0;
  }
`;

const ReviewSection = () => {
  const { registryInfo } = useRegistryState();

  const [currentStatus, setCurrentStatus] = useState('');

  const [apiMatching, setApiMatching] = useState(false);
  const [matchedTeams, setMatchedTeams] = useState([]);

  useEffect(() => {
    setMatchedTeams([]);
    if (!registryInfo.uniqid || !currentStatus) {
      return;
    }

    setApiMatching(true);
    SeasonRegistryResource.getReviewTeams({
      seasonRegistryUniqid: registryInfo.uniqid,
      statusList: [currentStatus],
    })
      .then(({ data }) => {
        setMatchedTeams(data);
      })
      .catch((e) => {
        toast(RMultilingual(`COMMON.UNKNOWN_ERROR`), { status: 'error', second: 1 });
      })
      .finally(() => {
        setApiMatching(false);
      });
  }, [registryInfo.uniqid, currentStatus]);

  const setStatus = (target) => () => {
    if (target === currentStatus) {
      setCurrentStatus('');
      return;
    }
    if (registryInfo.fee === 0 && ['REVIEW_COMPLETED', 'PAYMENT_CHECK_REQUESTED'].includes(target)) {
      return;
    }

    setCurrentStatus(target);
  };

  const reload = (newStatus) => {
    setCurrentStatus(newStatus);
  };

  return (
    <RegistrySectionDiv>
      {statusList.map((status) => (
        <Fragment key={status}>
          <StatusTitleDiv
            selected={status === currentStatus}
            disabled={registryInfo.fee === 0 && ['REVIEW_COMPLETED', 'PAYMENT_CHECK_REQUESTED'].includes(status)}
            onClick={setStatus(status)}
          >
            <h3 className="title">{RMultilingual(`TEAM_STATUS.${status}`)}</h3>
          </StatusTitleDiv>
          {status === currentStatus && (
            <ReviewTeamList loading={apiMatching} teams={matchedTeams} reload={reload} setTeams={setMatchedTeams} />
          )}
        </Fragment>
      ))}
    </RegistrySectionDiv>
  );
};

export default ReviewSection;
